module.exports = __webpack_public_path__ + "img/asia.f9a4f425.png";